module.exports = __webpack_public_path__ + "img/man-woman.4e3051e1.jpg";